module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-tabs__active-bar el-tabs__active-bar",
    class: ("is-" + (_vm.rootTabs.tabPosition)),
    style: (_vm.barStyle)
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63c01ab8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/tabs/tab-bar.vue
// module id = 2162
// module chunks = 137